import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { PresenterType } from '@app/shared';
import { PackageExportQueuedMessage } from './package-export-queued.message';

@PresenterType(
{
    model: PackageExportQueuedMessage
})
@Component({
  selector: 'package-export-queued-message',
  standalone: false,
  templateUrl: './package-export-queued-message.component.html',
  styleUrl: './package-export-queued-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackageExportQueuedMessageComponent {
    public data: WritableSignal<PackageExportQueuedMessage>;
    
    constructor() {
        this.data = signal<PackageExportQueuedMessage>(null);
    }
}
